export default __webpack_public_path__ + "a6bb914c53f16b62d3ece48ca221e9d6.svg";